import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

// Global moveNode function - must be defined before Alpine init
window.moveNode = function(source, destination) {
    if (!source || !destination) return;
    let dummy = document.createElement('span')
    source.before(dummy)
    destination.before(source)
    dummy.replaceWith(destination)
}

document.addEventListener('alpine:init', () => {
    Alpine.data('navFilters', () => ({
        hasLoaded: false,
        filtersHero: document.getElementById('filtersHero'),
        filtersHeader: document.getElementById('filtersHeader'),
        init() {

        },
        async toogleStickyFilters(displayFilters) {

            const scrollToTop = window.pageYOffset || document.documentElement.scrollTop;

            // loading | interactive | complete
            if (document.readyState === "loading") {
                // console.log('readyState = "loading"');
                return;
            }

            if (displayFilters) {

                // console.log('displayFilters = true');
                if(document.querySelector('.header .filters') == null ){
                    // console.log('Filters => Move to header');
                    window.moveNode(this.filtersHeader, this.filtersHero);
                }

            } else {

                // console.log('displayFilters = false');
                if(document.querySelector('.section-filters .filters') == null ){
                    // console.log('Filters => Move to content page');
                    window.moveNode(this.filtersHero, this.filtersHeader);
                }

            }

        },

    }))
})
